import React, { useEffect, useState } from 'react';
import API from '../../../utils/API'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import constants from '../../../utils/constants'
import { FormattedMessage } from 'react-intl';
import Toast from '../../../components/Toast/Toast';
import CopyIcon from '../../../assets/icons/common/copy.svg';
import EyeIcon from '../../../assets/icons/common/eye.svg';
import EyeOffIcon from '../../../assets/icons/common/eye-off.svg';
import './Configuration.css'

const Configuration = (props) => {
  const navigate = useNavigate();
  const { user } = props;
  const permissionIds = user.permissions.map((permission)=>{
    return permission.id
  });

  let [apiKey, setApiKey] = useState('');
  let [success, setSuccess] = useState('');
  let [error, setError] = useState('');
  let [showApiKey, setShowApiKey] = useState(false);
  let [centegixToken, setCentegixToken] = useState('');
  let [showToken, setShowToken] = useState(false);
  let [tokenInput, setTokenInput] = useState('');

  useEffect(() => {
    if(!permissionIds.includes(constants.permissionIds.aPlusEdit)){
      navigate('/forbidden');
    };
  }, [navigate, permissionIds]);

  const getApiKey = () => {
    // Use Centegix-specific API key method
    API.getCentegixApiKey(user.account.id).then((response) => {
      if(response.data.success){
        setApiKey(response.data.apiKey);
      }
    }).catch((error) => {
      console.error('Error getting Centegix API key:', error);
    });
  }

  const getCentegixToken = () => {
    API.getCentegixToken().then((response) => {
      if(response.data.token){
        setCentegixToken(response.data.token);
      }
    }).catch((error) => {
      console.error('Error getting Centegix token:', error);
    });
  }

  // Remove unused function since we're using implicit flow (token, not code)
  // const exchangeCodeForToken - removed

  useEffect(() => {
    getApiKey();
    getCentegixToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleManualTokenSubmit = async () => {
    if (!tokenInput.trim()) {
      setError(<FormattedMessage id="NO_CENTEGIX_TOKEN" defaultMessage="Please enter a token" />);
      return;
    }

    try {
      // Store the token directly without verification
      const storeResponse = await API.storeCentegixToken(tokenInput.trim());
      if (storeResponse.data.success) {
        console.log('storeResponse.data.success:', storeResponse.data.success);
        setCentegixToken(tokenInput.trim());
        setSuccess(<FormattedMessage id="CENTEGIX_TOKEN_STORE_SUCCESS" defaultMessage="Successfully stored Centegix token" />);
        setTokenInput('');
        // Refresh to get the stored token
        setTimeout(() => getCentegixToken(), 1000);
      }
    } catch (error) {
      console.error('Error storing token:', error);
      setError(<FormattedMessage id="CENTEGIX_TOKEN_STORE_ERROR" defaultMessage="Failed to store token. Please try again." />);
    }
  }

  const generateApiKey = () => {
    API.generateCentegixApiKey(user.email, user.id).then((response) => {
      console.log('response:', response);
      if(response.data.success){
        setApiKey(response.data.apiKey);
        setSuccess(<FormattedMessage id="GENERATE_API_KEY_SUCCESS" defaultMessage="Successfully generated an API Key" />)
      }
    }).catch((error) => {
      console.error('Error generating API key:', error);
      setError(<FormattedMessage id="GENERATE_API_KEY_ERROR" defaultMessage="Error generating API key" />)
    });
  }

  const copyApiKey = () => {
    navigator.clipboard.writeText(apiKey);
    setSuccess(<FormattedMessage id="API_KEY_COPIED" defaultMessage="API Key copied to clipboard" />)
  }

  const handleDisconnect = async () => {
    try {
      await API.disconnectCentegix();
      setCentegixToken('');
      setSuccess(<FormattedMessage 
        id="CENTEGIX_DISCONNECTED" 
        defaultMessage="Disconnected from Centegix successfully" 
      />);
    } catch (error) {
      setError(<FormattedMessage 
        id="CENTEGIX_DISCONNECT_ERROR" 
        defaultMessage="Failed to disconnect from Centegix" 
      />);
      console.error('Error disconnecting from Centegix:', error);
    }
  }

  return (
    <>
      <div className="title"><FormattedMessage id="CONFIGURATION" defaultMessage="CONFIGURATION" /></div>
      <div className="cardContainer">
        <div className="custom-card-header">
          <FormattedMessage id="SB_CLOUD_API_KEY" defaultMessage="SB Cloud API Key" />
        </div>
        <div className="blueWhiteButton mb-3" id="generateApiKeyBtn" onClick={generateApiKey}>
          <FormattedMessage id="GENERATE_API_KEY" defaultMessage="Generate API Key" />
        </div>
        <div className="grayInputField d-flex justify-content-between align-items-center" >
          <div className={`text-start ${apiKey ? 'api-key-display' : 'api-key-placeholder'}`}>
            {apiKey ? (showApiKey ? apiKey : '•'.repeat(Math.min(apiKey.length, 40))) : (
              <FormattedMessage id="NO_API_KEY" defaultMessage="No API Key" />
            )}
          </div>
          <div className="button-group">
            <button 
              className="copy-button" 
              onClick={() => setShowApiKey(!showApiKey)}
              disabled={!apiKey}
            >
              {showApiKey ? (
                <img src={EyeOffIcon} alt={<FormattedMessage id="HIDE" defaultMessage="Hide" />} />
              ) : (
                <img src={EyeIcon} alt={<FormattedMessage id="SHOW" defaultMessage="Show" />} />
              )}
            </button>
            <button 
              className="copy-button" 
              onClick={copyApiKey}
              disabled={!apiKey}
            >
              <img src={CopyIcon} alt={<FormattedMessage id="COPY" defaultMessage="Copy" />} />
            </button>
          </div>
        </div>
        <p className="row text-muted mt-4 mb-2">
          <FormattedMessage 
            id="API_KEY_DOCS_REFERENCE" 
            defaultMessage="Please refer to your documentation on how to Configure API access" 
          />
        </p>
      </div>
      {/* <div className="cardContainer mt-4">
        <div className="custom-card-header">
          <FormattedMessage id="CENTEGIX_AUTHENTICATION" defaultMessage="Centegix Authentication" />
        </div>
        {!centegixToken ? (
          <>
            <div className="grayInputField d-flex justify-content-between align-items-center">
              <div className="flex-grow-1">
                <input
                  type="text"
                  className="form-control border-0 bg-transparent p-0"
                  placeholder="Enter Centegix API token here"
                  value={tokenInput}
                  onChange={(e) => setTokenInput(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleManualTokenSubmit()}
                />
              </div>
              <button
                className="blueWhiteButton ms-2"
                id="saveCentegixTokenBtn"
                onClick={handleManualTokenSubmit}
                disabled={!tokenInput.trim()}
              >
                <FormattedMessage id="SAVE" defaultMessage="Save" />
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="grayInputField d-flex justify-content-between align-items-center mb-3">
              <div className={`text-start ${centegixToken ? 'api-key-display' : 'api-key-placeholder'}`}>
                {showToken ? centegixToken : '•'.repeat(Math.min(centegixToken.length, 40))}
              </div>
              <div className="button-group">
                <button 
                  className="copy-button" 
                  onClick={() => setShowToken(!showToken)}
                >
                  {showToken ? (
                    <img src={EyeOffIcon} alt={<FormattedMessage id="HIDE" defaultMessage="Hide" />} />
                  ) : (
                    <img src={EyeIcon} alt={<FormattedMessage id="SHOW" defaultMessage="Show" />} />
                  )}
                </button>
              </div>
            </div>
            <div className="disconnectBtn" id="disconnectCentegixBtn">
              <button
                type="button"
                onClick={() => {
                  if (window.confirm('Are you sure you want to disconnect from Centegix?')) {
                    handleDisconnect();
                  }
                }}
                aria-label="Disconnect from Centegix"
              >
                <FormattedMessage id="DISCONNECT_FROM_CENTEGIX" defaultMessage="Disconnect from Centegix" />
              </button>
              <span className="warning-text">
                <FormattedMessage
                  id="CENTEGIX_DISCONNECT_WARNING"
                  defaultMessage="This will remove the stored Centegix token. You can re-connect later."
                />
              </span>
            </div>
          </>
        )}
        {centegixToken && (
          <p className="row text-muted mt-4 mb-2">
            <FormattedMessage 
              id="CENTEGIX_TOKEN_EXPIRATION" 
              defaultMessage="IMPORTANT: Store this token securely. You may need to renew it based on your Centegix configuration." 
            />
          </p>
        )}
      </div> */}
      <Toast 
        success={success}
        error={error}
        setSuccess={setSuccess}
        setError={setError}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(Configuration);